/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__add = () => `Añadir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back = () => `Volver`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_home = () => `Volver a la página de inicio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_overview = () => `Volver a la vista preliminar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_to_search = () => `Volver a buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__close_panel = () => `Reducir panel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__delete = () => `Borrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__edit = () => `Modificar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__modify = () => `Modificar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__open_panel = () => `Abrir el panel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__print = () => `Imprimir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__retry = () => `Volver a intentar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__save = () => `Guardar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__save_close = () => `Guardar y cerrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_in = () => `Abrir sesión`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_up = () => `Inscripción`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__validate = () => `Confirmar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__article_button = () => `Leer el artículo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__badge_text = () => `Magazine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__button_label = () => `Viajar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__first_line = () => `Nuestros destinos imprescindibles y todas nuestras inspiraciones viajeras están en`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_button = () => `Descubrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_subtitle = () => `Descubre nuestros consejos de viaje y déjate guiar por el Magazine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_title = () => `¿Necesitas inspiración?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__second_line = () => `Revista ViaMichelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__detail = () => `No hemos podido obtener la información.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__title = () => `Lugar no encontrado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alert_itinerary__closed_roads__cta = () => `Bypass`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__close_button__label = () => `Cerrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__no_events__label = () => `Actualmente no hay alertas en la zona seleccionada.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__select_location__label = () => `Para ver alertas, ingrese una ubicación en el cuadro de búsqueda.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__add__itinerary = () => `Añadir este itinerario a favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_car = () => `Coche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_caravan = () => `Caravana`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_electricCar = () => `Coches eléctricos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_motorcycle = () => `Moto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__delete_favorite_ariaLabel = () => `Eliminar ruta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite__routes = () => `Itinerarios favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached = () => `Has alcanzado el límite de itinerarios guardados en favoritos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached__cta = () => `Ver favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__find_favorites_routes = () => `Acceder a mis itinerarios favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_deleted__success = () => `Itinerario eliminada de favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error = () => `No se ha podido añadir este itinerario a favoritos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error__cta = () => `Inténtalo de nuevo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary__saved = () => `Itinerario guardado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary_saved = () => `Ruta añadida a favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__no_saved_itineraries = () => `No tienes ningún itinerario en favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__save_favorite_route = () => `Guarda tus itinerarios favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see = () => `Ver favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see_favorite_route = () => `Ver itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_actions = () => `Acciones (eliminar o ver ruta)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_iti_details = () => `Detalles de la ruta (salida, llegada, etapas)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__via = () => `A través de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__placeholder = () => `Llegada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__title = () => `Selecciona una fecha de llegada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__cancel = () => `Borrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__validate = () => `Confirmar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__arrival_placeholder = () => `Fecha de llegada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__close_aria_label = () => `Borrar fechas seleccionadas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__departure_placeholder = () => `Salida`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__one = () => `noche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__other = () => `noches`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__trigger_aria_label = () => `Seleccione la fecha de inicio y fin utilizando el widget de calendario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__back_home = () => `volver a la página de inicio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__or = () => `o`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_end = () => `si no encuentras lo que buscas.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_start = () => `Puedes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__title = () => `Esta página ha sido eliminada o modificada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_end = () => `por ayuda.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_start = () => `Nuestro equipo está trabajando para resolver el problema. Puedes volver a intentarlo más tarde o`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__title = () => `La página no se pudo cargar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__contact_us = () => `ponerte en contacto con nosotros`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__many = (params) => `${params.count} plazas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__one = () => `1 plaza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const favoriteItineraries__deleteError = () => `Esta ruta no ha podido ser eliminada de tus favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__faq_title = () => `Preguntas más frecuentes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__magazine_button = () => `Navegar por el ViaMichelin Magazine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__newsletter_button = () => `Suscríbase a nuestro boletín`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B10 = () => `Diésel premium`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B7 = () => `Diésel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__CNG = () => `Metano`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E10 = () => `SP 95 - E10`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5 = () => `SP 95`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5_98 = () => `SP 98`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E85 = () => `Etanol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__H2 = () => `H2`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__LPG = () => `GLP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const highways = () => `Autopistas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const input__clear = () => `Borrar entrada`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__ad__loading = (params) => `Tu itinerario en ${params.count} s`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__add_step = () => `Añadir escala`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__compute = () => `Buscar itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__current_location = () => `Tu ubicación actual`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__edit = () => `Modificar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__invert = () => `Invertir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__max_steps_reached = () => `Número máximo de escalas alcanzado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__edit = () => `Modificar su vehículo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__register = () => `Añadir tu vehículo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__user = () => `Mi vehículo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__bifuel = () => `Bicombustible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__cng = () => `GNC`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__diesel = () => `Diesel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__electric = () => `Eléctrico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__ethanol = () => `Etanol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__gasoline = () => `Gasolina`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hybrid = () => `Híbrido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hydrogen = () => `Hidrógeno`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__lpg = () => `GLP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__city = () => `Urbano`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__compact = () => `Compacto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__saloon = () => `Berlina`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__sports = () => `Deportivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__suv = () => `SUV`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle = () => `Viaja con una caravana`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle_helper_text = () => `Adapta los datos de coste, duración del trayecto y consumo, pero no el itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__error = () => `No se han podido mostrar los vehículos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__retry = () => `Volver a intentarlo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_border_crossing = () => `Evitar salir del territorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_ferry = () => `Evitar conexiones marítimas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_low_emission_zone = () => `Evitar zonas de bajas emisiones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_motorway = () => `Evitar vías rápidas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_toll = () => `Evitar peajes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_vignette = () => `Evitar compra de viñeta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__none = () => `Ninguna`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency = () => `Divisa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__chf = () => `CHF - Franco suizo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__czk = () => `Kč - Corona checa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__dkk = () => `kr - Corona danesa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__eur = () => `€ - Euro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__gbp = () => `£ - Libra esterlina`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__hrk = () => `kn - Kuna croata`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__huf = () => `Ft - Florín húngaro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__jpy = () => `¥ - Yen japonés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__nok = () => `kr - Corona noruega`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__pln = () => `zł - Esloti polaco`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__sek = () => `kr - Corona sueca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__uah = () => `₴ - Grivna ucraniana`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__usd = () => `$ - Dólar estadounidense`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__distance_unit = () => `Unidad de distancia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__ev_toggle = () => `Estás conduciendo un vehículo eléctrico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__fuel__price = () => `Precio por litro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__kwh__price = () => `Precio por kWh`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__bike = () => `En bicicleta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car = () => `En coche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit = () => `Recarga cuando llegues a…`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit_warning_message = () => `Variables como la temperatura, el viento o el número de pasajeros pueden tener un impacto sobre la autonomía de tu vehículo eléctrico. Acuérdate de prever un margen de maniobra suficiente.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__motorcycle = () => `En moto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__walk = () => `A pie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__title = () => `Parámetros de tu trayecto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__traffic_toggle = () => `Evitar los atascos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__travel_mode = () => `Tu medio de transporte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__trip_constraint = () => `Tus preferencias en carretera`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__imperial = () => `Millas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__metric = () => `Kilómetros`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__recompute = () => `Buscar itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__summary__traffic_avoided_badge = () => `Tráfico evitado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__restStop__description = () => `recomienda esta zona para familias`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__village__description = () => `Recomiendo este pueblo de parada obligatoria para familias.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_add_car = () => `Añada su vehículo para obtener estimaciones de costos más precisas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create = () => `Cree su cuenta en unos pocos clics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create_account = () => `Crear una cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_ideas = () => `Llene su maleta de ideas: descubra nuestros destinos estrella y nuestros road trips gracias a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_more = () => `Más información`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_newsletter = () => `nuestro boletín`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_save_pref = () => `Guarde sus preferencias de ruta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_signin = () => `Suscribirse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_cta_label = () => `Calcule`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_notification = () => `Introduzca una salida y una llegada para ver los detalles del coste de la ruta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_title = () => `El coste detallado de sus viajes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__headline_title = () => `En ViaMichelin, puede encontrar ...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_cta_label = () => `Visite la revista`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_title = () => `Contenidos que le inspirarán`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__pois_hrt = () => `Ver puntos de interés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_cta_label = () => `Descubra la selección`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_title = () => `Toda la selección Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_cta_label = () => `Descubra`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_notification = () => `Introduzca una salida y una llegada para encontrar las escalas propuestas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_title = () => `Ideas de paradas en el camino`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__header = () => `Apariencia de tu mapa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__image_alt = () => `Duplicado historial`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__label = () => `Historial`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__image_alt = () => `Duplicado híbrido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__label = () => `Híbrido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__imagex_alt = () => `Duplicado Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__label = () => `Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__imagex_alt = () => `Mapa de carreteras pintorescas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__label = () => `Carreteras pintorescas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__confidentiality_policy = () => `Política de privacidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__contact = () => `Póngase en contacto con nosotros`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__cookies = () => `Cookies`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__credits = () => `Créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__legal_notice = () => `Aviso legal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__term_of_use = () => `Condiciones de uso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__error = () => `No hemos podido determinar tu ubicación exacta.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__header = () => `Tu ubicación está desactivada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__text = () => `Modifica los ajustes de tu navegador para autorizar el acceso a tu ubicación.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__close_button = () => `Cerrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__failure = () => `No se pudo iniciar sesión`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__success = () => `Sesión iniciada con éxito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__access_profile = () => `Acceder a mi perfil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__compass = () => `Brújula`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__location = () => `Ubicación`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__login_profile = () => `Acceder a mi perfil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__profile = () => `Perfil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__settings = () => `Ajustes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_in = () => `Acercar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_out = () => `Alejar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel = () => `Hoteles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel__long_label = () => `Buscar alojamiento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__go_to_traffic_info_page__label = () => `Alertas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__low_emission_zone__label = () => `Zonas de bajas emisiones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info__label = () => `Ver`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_busy__label = () => `Densa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_closed_lane__label = () => `Carretera cerrada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_display_alerts__label = () => `Mostrar alertas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_fluid__label = () => `Fluida`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_heavy__label = () => `Saturada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__bookTheFork = () => `Widget de reserva de TheFork`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__close = () => `Cerrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__locale_switch_title = () => `ViaMichelin está disponible en varios idiomas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const other_roads = () => `Otros itinerarios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__first = () => `Primera página`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__last = () => `Última página`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__nav = () => `Paginación Navegación`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__next = () => `Página siguiente`


/**
 * @param {{ page: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page = (params) => `Página ${params.page}`


/**
 * @param {{ page: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page_active = (params) => `Página ${params.page}, página actual`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__prev = () => `Página anterior`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__end_of_results = () => `Fin de los resultados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__next = () => `Siguiente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__previous = () => `Anterior`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poiCard__seeDetails = () => `Ver detalles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__activities = () => `Actividades`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__add_to_itinerary = () => `Paso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__book = () => `Reservar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__cancel = () => `Anular`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__details = () => `Detalles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__itinerary = () => `Itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__actions_book = () => `Reservar`


/**
 * @param {{ average: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__average_price = (params) => `Aprox. ${params.average}`


/**
 * @param {{ price: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__book_min_price = (params) => `Reservar desde ${params.price}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__aria_label = () => `Carrusel de imágenes para`


/**
 * @param {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__list_aria_label = (params) => `${params.current} imagen en ${params.total}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__next_button = () => `Ver el siguiente contenido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__prev_button = () => `Ver contenido anterior`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__many = (params) => `Máx ${params.count} kW`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__one = (params) => `${params.count} kW`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__count_more_than_3_connectors = (params) => `+ ${params.count} más`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__image_alt = () => `Imagen del lugar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__michelin = () => `Guía Michelin`


/**
 * @param {{ min: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__min_price = (params) => `A partir de ${params.min}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__non_availability = () => `Completo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_tag_average = () => `Aprox.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_unavailable = () => `Precio no disponible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__bad = () => `Malo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__disappointing = () => `Decepcionante`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__exceptional = () => `Notable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__fabulous = () => `Fantástico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__good = () => `Bueno`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__mediocre = () => `Mediocre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__passable = () => `Regular`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__pleasant = () => `Agradable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__quite_mediocre = () => `Bastante mediocre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__superb = () => `Magnífico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__very_good = () => `Muy bien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__well = () => `Bueno`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review_count = (params) => `${params.count} opiniones`


/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__updated = (params) => `el ${params.date}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__accommodation = () => `Alojamientos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__ev_service = () => `Puntos de recarga`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__gas_station = () => `Estaciones de servicio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__parking = () => `Aparcamientos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__rest_stop = () => `Áreas de descanso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__restaurant = () => `Restaurantes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__tourism = () => `Turismo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__header = () => `Puntos de interés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__not_available = () => `Los puntos de interés no pueden mostrarse en esta página.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__select_all = () => `Mostrar todo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__unselect_all = () => `Ocultar todo`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__many__overnight_stay = (params) => `Disponibilidad para ${params.count} noches con`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__one__overnight_stay = () => `Disponibilidad para 1 noche con`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability = () => `Fechas de la estancia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__error = () => `No se ha podido mostrar la información.`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__many__other = (params) => `${params.count} diferentes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__one__other = () => `1 diferente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view_more__on_partner_website = () => `Ir a Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__with = () => `Disponibilidad con`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability_offer = (params) => `Oferta ${params.count}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__back_to_list = () => `Volver a la lista`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__carousel__close_button = () => `Cerrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__description = () => `A propósito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__bb = () => `B&B`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__camping = () => `Camping`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__hotel = () => `Hotel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__residence = () => `Residencia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__rest = () => `Área de descanso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__service = () => `Área de servicio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__image_alt = () => `Imagen del lugar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__location = () => `Ubicación`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion = () => `La opinión de la Guía Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion__tourism = () => `La opinión de la Guía Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__practical_info = () => `Información práctica`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = () => `Descubrir en GetYourGuide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found = () => `No se han podido visualizar las actividades.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_with_region = () => `No encontramos ninguna actividad cerca, pero hay muchas otras en esta zona.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = () => `No encontramos ninguna actividad cerca, pero hay muchas otras en esta zona.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label = () => `Descubrir en GetYourGuide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__not_found_image_alt = () => `Bib mirando al horizonte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__title = () => `También te puede gustar...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_more = () => `Ver más`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_on_map = () => `Ver en la mapa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__strong_points = () => `Puntos fuertes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__back = () => `Cerrar filtros avanzados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__detailed_view__label = () => `Mostrar precio, número de estrellas...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__fetch_error = () => `No se ha podido mostrar la información.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__no_selected_categories = () => `Active una categoría superior para`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__only__michelin = () => `Sólo selección Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__select_to_filter = () => `mostrar los filtros correspondientes.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__all = () => `Todas`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__many = (params) => `${params.count} selecciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__none = () => `Ningún filtro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__one = () => `1 selección`


/**
 * @param {{ hours: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__last_update = (params) => `${params.hours}h máx`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_count = (params) => `${params.count} y más`


/**
 * @param {{ power: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_power = (params) => `Mínimo ${params.power}kW`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__eur = (params) => `${params.amount} € y más`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__usd = (params) => `$${params.amount} y más`


/**
 * @param {{ minRate: NonNullable<unknown>, maxRate: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_rate = (params) => `Mínimo ${params.minRate}/${params.maxRate}`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__one = (params) => `${params.count} estrella y más`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__other = (params) => `${params.count} estrellas y más`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__none = () => `Ningún filtro`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__eur = (params) => `${params.amount} €`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__usd = (params) => `$${params.amount}`


/**
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__eur = (params) => `${params.minAmount}€ a ${params.maxAmount}€`


/**
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__usd = (params) => `$${params.minAmount} a $${params.maxAmount}`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__stars = (params) => `${params.count} estrellas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button = () => `Filtros abiertos`


/**
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__many = (params) => `${params.numberOfFilters} filtros activados`


/**
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__one = (params) => `${params.numberOfFilters} filtro activado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_category = () => `Para ver los puntos de interés (hoteles, restaurantes, etc.), debes seleccionar al menos una categoría.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_result = () => `No hemos encontrado ningún punto de interés con estos criterios en esta zona. Vuelve a intentarlo ampliando la zona de búsqueda.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__filters__toggle_label = () => `Filtrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_marker__pin = () => `Pin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_search_category__aria_label = () => `Buscar en`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__close = () => `Cerrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__login = () => `Abrir sesión`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__logout = () => `Cerrar sesión`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__favorites__title = () => `Itinerarios favoritos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__banner = () => `Estos datos están vinculados a tu cuenta Michelin.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__email = () => `Dirección de correo electrónico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__name = () => `Nombre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__password = () => `Contraseña`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__modify = () => `Modificar en michelin.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__title = () => `Información de la cuenta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__banner = () => `También podrás modificar estos parámetros al buscar tu itinerario.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__title = () => `Parámetros de itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__vehicle = () => `Tu vehículo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const refresh_control__label = () => `Actualizar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__construction_year = () => `Año`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__fuel = () => `Carburante`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__text = () => `Actualizamos regularmente nuestra base de datos. Si su vehículo no aparece en la lista, elija un modelo similar o uno de nuestros vehículos predeterminados.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__title = () => `¿No encuentra su vehículo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__motor = () => `Motorización`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_subtitle = () => `Para añadir tu vehículo debes tener una cuenta Michelin.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_title = () => `¿Tienes una cuenta?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__fill_to_save = () => `Para guardar, debes rellenar todos los campos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_error = () => `Ha habido un fallo al guardar. Por favor, vuelve a intentarlo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_success = () => `Tu vehículo ha sido guardado.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__search_placeholder = () => `Marca y modelo del vehículo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__vehicle = () => `Vehículo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__dogArea = () => `Área canina`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__nursery = () => `Guardería`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__picnicTable = () => `Mesa de picnic`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__playGround = () => `Zona de juegos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__restaurant = () => `Restaurante`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__shop = () => `Tienda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restaurantMichelin_greenStarLabel = () => `Gastronomía sostenible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road__detailed_instructions = () => `Instrucciones detalladas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road__distribution_routes = () => `Distribución de las carreteras`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road_typology = () => `Tipología de carreteras`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roadsheet__scenic_roads = () => `Rutas panorámicas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__arrival = () => `Llegada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__alternative = () => `Alternativa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__discovery = () => `Descubra`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__ecological = () => `Ecológica`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__economic = () => `Económica`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__quickest = () => `Rápida`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__shortest = () => `Corto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__departure = () => `Salida`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__details = () => `Continuar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__error = () => `No se ha podido mostrar la información.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__final_charge = () => `Llegada a`


/**
 * @param {{ tollCost: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__included_costs = (params) => `incluido ${params.tollCost} de peajes`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__many = (params) => `${params.count} itinerarios posibles`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__one = (params) => `${params.count} itinerario recomendado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__not_found = () => `No hemos encontrado ningun itinerario. ¿Puedes modificar tu búsqueda?`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__recharge = (params) => `${params.count} recarga(s)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__selected = () => `Restricción(es) en este trayecto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__unselected = () => `Restricción(es) previsibles en este trayecto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_cost = () => `Coste`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_distance = () => `Distancia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_duration = () => `Duración`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_electricity_consumption = () => `Consumo de electricidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_emission = () => `Emisiones de CO2`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_error_message = () => `Intente modificar su búsqueda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_address = () => `Lugares desconocidos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_road = () => `No hay itinerario.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__alternative = () => `marcador en el itinerario alternativo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__default = () => `marcador en el itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__discovery = () => `marcador en la ruta de descubrimiento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__ecological = () => `marcador en el itinerario ecológico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__economic = () => `marcador en el itinerario económico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__quickest = () => `marcador en el itinerario más rápido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__shortest = () => `marcador en el itinerario más corto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__step = () => `escala`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs = () => `Coste`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__costs_details = () => `Detalle de los costes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__electricity = () => `Electricidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__estimated_for = () => `Coste estimado para`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__fuel = () => `Carburante`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls = () => `Peajes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls_list = () => `Lista de peajes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__total_cost = () => `Coste total del trayecto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__vignette = () => `Viñeta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note = () => `Nota de gastos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__allowance = () => `Kilometraje a tanto alzado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__arrival = () => `Llegada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__back = () => `Volver a la nota de gastos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__costs = () => `Gastos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__date = () => `Fecha`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__departure = () => `Salida`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__distance = () => `Distancia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data = () => `Información complementaria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data_placeholder = () => `Cualquier otra información útil.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance = () => `A tanto alzado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance_input = () => `Compensación por kilometraje`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__compute_method = () => `Método de cálculo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__electricity = () => `Coste de la electricidad (€/kWh)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__fuel = () => `Coste del carburante (€/litro)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity = () => `Identidad del solicitante`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity_placeholder = () => `Nombre y apellido(s)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__include = () => `Incluir los elementos siguientes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__legal_info = () => `Información legal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__real = () => `Cálculo real`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__title = () => `Modificar la nota de gastos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__travel_date = () => `Fecha del viaje`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__electricity = () => `Electricidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__fuel = () => `Carburante`


/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__generated_on = (params) => `Generado por ViaMichelin, el ${params.date}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__identity = () => `Solicitante`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__notes = () => `Descripción`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__tolls = () => `Peajes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__total = () => `Total`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__travel = () => `Detalles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__vignette = () => `Viñetas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions = () => `Instrucciones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions__error = () => `No se han podido mostrar las instrucciones de navegación.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way = () => `Por el camino`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__detour = () => `Por el camino`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__infos = () => `Corresponde a la distancia entre tu viaje y los puntos de interés propuestos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__scope = () => `Alcance de la búsqueda`


/**
 * @param {{ value: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__up_to = (params) => `Hasta ${params.value} km`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__recommendations = () => `A descubrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__cta = () => `Compartir coche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__description = () => `Importe medio registrado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__subtitle = () => `con`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__title = () => `Ahorra 60 euros`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__button_label = () => `Costes detallados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__ev_charging = () => `Energía`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__fuel = () => `Combustible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__title = () => `Coste de este viaje`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__tolls = () => `Peajes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__on_the_road__title = () => `En la ruta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__rest_stop__button_label = () => `Ideas para hacer escala`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__button_label = () => `Mapa de carreteras`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__emissions = () => `Emisiones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__ev_charging = () => `Recambios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__highway = () => `Vías rápidas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__title = () => `Mapa de carreteras`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__cta_label = () => `Ver el alojamiento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__title = () => `Alojamiento a la llegada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_label = () => `Publicar mi viaje`


/**
 * @param {{ device: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_url = (params) => `https://www.blablacar.es/offer-seats?comuto_cmkt=es_viamichelin_acq_drvr_bonuscovoiturage_boxfdr${params.device}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__description = () => `Comparte los gastos de tu viaje al publicar tus asientos vacios.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__legal_notice = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__title = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_label = () => `Ofrecer mis plazas libres`


/**
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown>, device: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_url = (params) => `https://www.blablacar.es/offer-seats?from=${params.departure}&to=${params.arrival}&comuto_cmkt=ES_VIAMICHELIN_DRVR_NEWSITE_SUDR&utm_source=VIAMICHELIN&utm_medium=Link&utm_campaign=ES_VIAMICHELIN_DRVR_NEWSITE_SUDR`


/**
 * @param {{ cost: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__description = (params) => `Ahorra hasta ${params.cost}€`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__legal_notice = () => ``


/**
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__title = (params) => `${params.departure} - ${params.arrival}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search__input__aria_label = () => `¿Adónde vamos?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__aria_label = () => `Itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__text = () => `Itinerario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__empty = () => `No se ha encontrado ningún resultado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__error = () => `Se ha producido un error.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__image_alt = () => `Bib observant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__results__aria_label = () => `Resultados de la búsqueda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const settings__close = () => `Cerrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__close_button = () => `Cerrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__loading = () => `Cerrando sesión...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__logged_out = () => `Sesión cerrada con éxito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const soon = () => `Próximamente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_deviation__cta = () => `Ignorar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_accident = () => `Accidente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_dangerous = () => `Carretera cerrada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_incident = () => `Incidente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__construction_cone = () => `Trabajo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__lane_closed = () => `Contracción`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__weather_hail = () => `Tiempo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_info_settings__header = () => `ESTADO DEL TRÁFICO`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__go_to_partner_website = () => `Ir a Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__no_room = () => `No hay disponibilidad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on = () => `Hemos encontrado pocos alojamientos que coincidan con tu búsqueda. Para más opciones, visita`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on_partner_website = () => `Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__ev_only = () => `Sólo con estaciones de carga`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range = () => `Alcance de la búsqueda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__text = () => `Corresponde a la distancia entre tu viaje y los puntos de interés propuestos.`


/**
 * @param {{ value: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__value = (params) => `Hasta ${params.value} km`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__notToBeMissed = () => `No se lo pierda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois__see_all = () => `Ver más`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_subtitle = () => `Nuestras recomendaciones de alojamiento, restaurantes...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_title = () => `Puntos de interés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__title = () => `Ideas de paradas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__available_accommodation = () => `Hay alojamiento disponible en tu área de destino.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__see_accommodation_zone = () => `Ver en la mapa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__error = () => `No se pudieron mostrar los puntos de interés.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__image_alt = () => `Área de interés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__see_on_map = () => `Ver en el mapa`
